import { combineSlices } from "@reduxjs/toolkit";
import { fleetBaseApi } from "../../features/fleet/fleetApi";
import { authSlice } from "../../features/auth/authSlice";
import { fleetTaskFormSlice } from "../../features/fleet/fleetTaskFormSlice";
import { dimensionsBaseApi } from "../../features/dimensions/dimensionsApi";
import { monarchBaseApi } from "../../features/monarch/monarchApi";
import { cinemasBaseApi } from "../../features/cinemas/cinemasApi";

const slices = [authSlice, fleetTaskFormSlice];
const apis = [fleetBaseApi, dimensionsBaseApi, monarchBaseApi, cinemasBaseApi];

export const apiMiddlewares = apis.map((api) => api.middleware);
export const rootReducer = combineSlices(...slices, ...apis);
